import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CategoryFileFragmentDoc } from '../../fragment/generated/CategoryFile';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MoveFileMutationVariables = Types.Exact<{
  data: Types.MoveFileInput;
}>;


export type MoveFileMutation = { moveFile?: { newParent?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null, oldParent?: { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null } | null } | null };


export const MoveFileDocument = /*#__PURE__*/ gql`
    mutation MoveFile($data: MoveFileInput!) {
  moveFile(data: $data) {
    newParent {
      ...CategoryFile
    }
    oldParent {
      ...CategoryFile
    }
  }
}
    ${CategoryFileFragmentDoc}`;

export function useMoveFileMutation() {
  return Urql.useMutation<MoveFileMutation, MoveFileMutationVariables>(MoveFileDocument);
};